import * as Sentry from "@sentry/react";

const environment = process.env.REACT_APP_ENV;
const dsn = process.env.REACT_APP_SENTRY_DSN;

// Initialiser Sentry si DSN défini
if (dsn) {

  let integrations = [];
  let tracePropagationTargets = [];

  // Tracing Integration
  integrations.push(Sentry.browserTracingIntegration());
   // Sentry.browserProfilingIntegration(), --> si ajout, add Document-Policy "js-profiling" headers

  if (environment === 'staging') {
    // Replay Integration
    integrations.push(Sentry.replayIntegration());
    // URL tracing staging
    tracePropagationTargets.push(/^https:\/\/direct-staging\.dsasapp\.com/);
  } else if (environment === 'production') {
    // URL tracing production
    tracePropagationTargets.push(/^https:\/\/direct\.dsasapp\.com/);
  }

  // Conf Sentry
  Sentry.init({
    dsn: dsn,
    integrations: integrations,
    environment: environment,
    // Tracing
    tracesSampleRate: 1.0, // Capture 100% des transactions
    tracePropagationTargets: tracePropagationTargets,
    // Profiling
    profilesSampleRate: 1.0,  // Profilage des transactions
    // Session Replay
    replaysSessionSampleRate: 0.1,  // Échantillonnage des sessions
    replaysOnErrorSampleRate: 1.0,  // Échantillonnage des sessions en cas d'erreur
  });

} else {
  console.log('Sentry non initialisé - Aucun DSN défini.');
}
